import { ReactElement } from 'react';
import { IntlShape } from 'react-intl';

export const dictionary = {
    faq__title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.onboarding.ecb05d02352a1a879c09b1a6881bd0cb',
            defaultMessage: 'Any questions?',
            description: 'Заголовок списка вопросов на онбординге',
        }),
    faq__what_is_yango_play_title: (intl: IntlShape, { brandName }: { brandName: string }) =>
        intl.formatMessage(
            {
                id: 'features.onboarding.b267611981172e3ad2ef1416c975d778',
                defaultMessage: 'What is {brandName}?',
                description: 'Заголовок вопроса в разделе «Вопросы и ответы»',
            },
            { brandName }
        ),
    faq__what_is_yango_play_answer: (intl: IntlShape, { brandName }: { brandName: string }) =>
        intl.formatMessage(
            {
                id: 'features.onboarding.858a3f4697d4807f2df003bb465ce384',
                defaultMessage:
                    '{brandName} lets you watch TV series and movies, listen to music, play games — all in one app.',
                description: 'Текст ответа на вопрос в разделе «Вопросы и ответы»',
            },
            { brandName }
        ),
    faq__how_can_i_join_title: (intl: IntlShape, { brandName }: { brandName: string }) =>
        intl.formatMessage(
            {
                id: 'features.onboarding.a99dbbae75a8eb314dfc6a5b71301a43',
                defaultMessage: 'How can I join {brandName}?',
                description: 'Заголовок вопроса в разделе «Вопросы и ответы»',
            },
            { brandName }
        ),
    faq__how_can_i_join_answer: (
        intl: IntlShape,
        { br, brandName }: { br: ReactElement; brandName: string }
    ) =>
        intl.formatMessage(
            {
                id: 'features.onboarding.925ad17771d3c065609236e183ae8381',
                defaultMessage:
                    'There are several ways to get {brandName}:{br}1. Download the {brandName} app and get the subscription{br}2. Go to play.yango.com and get the subscription{br}3. Download the {brandName} app for Smart TV and follow the instructions',
                description: 'Текст ответа на вопрос в разделе «Вопросы и ответы»',
            },
            { br, brandName }
        ),
    faq__not_working_after_payment_title: (intl: IntlShape, { brandName }: { brandName: string }) =>
        intl.formatMessage(
            {
                id: 'features.onboarding.bd8a82db0d0fa8ea7cfe53076edfa240',
                defaultMessage: 'What can I do if {brandName} doesn’t work after I paid?',
                description: 'Заголовок вопроса в разделе «Вопросы и ответы»',
            },
            { brandName }
        ),
    faq__not_working_after_payment_answer: (
        intl: IntlShape,
        { brandName }: { brandName: string }
    ) =>
        intl.formatMessage(
            {
                id: 'features.onboarding.c8e191ba678a97500973d26068c9d4dd',
                defaultMessage:
                    "Make sure you're logged in to your {brandName} account. If it has been less than 24 hours since your payment, we may still be waiting for your subscription to be confirmed. If you have any difficulties, please contact Customer Care.",
                description: 'Текст ответа на вопрос в разделе «Вопросы и ответы»',
            },
            { brandName }
        ),
    faq__cancel_subscription_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.onboarding.19358d2d01d0cc8387dc81b897745576',
            defaultMessage: 'How can I cancel my subscription?',
            description: 'Заголовок вопроса в разделе «Вопросы и ответы»',
        }),
    faq__cancel_subscription_answer: (intl: IntlShape, { brandName }: { brandName: string }) =>
        intl.formatMessage(
            {
                id: 'features.onboarding.2d7a63d4eb8ea3d37e1023388061ff11',
                defaultMessage:
                    'You can cancel your subscription in your account. Click Subscription in the {brandName} menu, then scroll down and click Cancel the subscription.',
                description: 'Текст ответа на вопрос в разделе «Вопросы и ответы»',
            },
            { brandName }
        ),
    faq__manage_subscription_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.onboarding.ecba104e985811984b4af6c4148d4cf3',
            defaultMessage: 'How can I manage my subscription?',
            description: 'Заголовок вопроса в разделе «Вопросы и ответы»',
        }),
    faq__manage_subscription_answer: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.onboarding.f06345ce1e529179638e2f16e5adbced',
            defaultMessage:
                'You can manage your subscription from your account. Click on the Manage subscription widget on the main page to see the details of your subscription.',
            description: 'Текст ответа на вопрос в разделе «Вопросы и ответы»',
        }),
    faq__where_available_title: (intl: IntlShape, { brandName }: { brandName: string }) =>
        intl.formatMessage(
            {
                id: 'features.onboarding.22036919b8a2cb808de3cf299dcdbb03',
                defaultMessage: 'Where is {brandName} available?',
                description: 'Заголовок вопроса в разделе «Вопросы и ответы»',
            },
            { brandName }
        ),
    faq__where_available_answer: (intl: IntlShape, { brandName }: { brandName: string }) =>
        intl.formatMessage(
            {
                id: 'scenarios.home.i18n.faq.cd192ec0df2be2e41bbf755aa99f2ce3',
                defaultMessage:
                    '{brandName} is currently available in the United Arab Emirates, Qatar, Oman, Bahrain, Kuwait, Jordan and Egypt.',
                description: 'Текст ответа на вопрос в разделе «Вопросы и ответы»',
            },
            { brandName }
        ),
    faq__devices_languages_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'features.onboarding.39f166fa5854896b0c5c7144e614f692',
            defaultMessage: 'What devices and languages are supported?',
            description: 'Заголовок вопроса в разделе «Вопросы и ответы»',
        }),
    faq__devices_languages_answer: (intl: IntlShape, { brandName }: { brandName: string }) =>
        intl.formatMessage(
            {
                id: 'features.onboarding.8992b6c981fca914fbaf4dbc21c5f63c',
                defaultMessage:
                    '{brandName} is available in both English and Arabic on various platforms, such as smartphones (Android and iOS-based devices) and smart TVs',
                description: 'Текст ответа на вопрос в разделе «Вопросы и ответы»',
            },
            { brandName }
        ),
    faq__what_is_title: (intl: IntlShape, { brandName }: { brandName: string }) =>
        intl.formatMessage(
            {
                id: 'allplay.faq_what_is_title',
                defaultMessage: 'What is {brandName}?',
                description: 'Заголовок вопроса в разделе «Вопросы и ответы»',
            },
            { brandName }
        ),
    faq__what_is_answer: (intl: IntlShape, { brandName }: { brandName: string }) =>
        intl.formatMessage(
            {
                id: 'allplay.faq_what_is_answer',
                defaultMessage:
                    '{brandName} is a catalog of online cinemas and TV channels in one subscription.',
                description: 'Текст ответа на вопрос в разделе «Вопросы и ответы»',
            },
            { brandName }
        ),
    faq__how_connect_title: (intl: IntlShape, { brandName }: { brandName: string }) =>
        intl.formatMessage(
            {
                id: 'allplay.faq_how_connect_title',
                defaultMessage: 'How can I sign up for {brandName}?',
                description: 'Заголовок вопроса в разделе «Вопросы и ответы»',
            },
            { brandName }
        ),
    faq__how_connect_answer: (
        intl: IntlShape,
        {
            brandName,
            br,
            bold,
            allplayLink,
        }: {
            brandName: string;
            br: ReactElement;
            bold: (chunks: any) => ReactElement;
            allplayLink: (chunks: any) => ReactElement;
        }
    ) =>
        intl.formatMessage(
            {
                id: 'allplay.faq_how_connect_answer',
                defaultMessage:
                    'You can use {brandName} with a Yandex Plus Multi or Yandex Plus Multi & Amediateka subscription. You can also add {brandName} separately to your existing Yandex Plus subscription.{br}{br}<bold>Smartphone</bold>{br}Download the {brandName} app from the App Store or Google Play and activate your subscription.{br}{br}<bold>Website</bold>{br}Go to <allplayLink>allplay.uz</allplayLink> to subscribe to {brandName}.{br}{br}<bold>Smart TV</bold>{br}Install the {brandName} app on your TV and follow the on-screen instructions to sign up.',
                description: 'Текст ответа на вопрос в разделе «Вопросы и ответы»',
            },
            { brandName, br, bold, allplayLink }
        ),
    faq__subscription_includes_title: (intl: IntlShape, { brandName }: { brandName: string }) =>
        intl.formatMessage(
            {
                id: 'allplay.faq_subscription_includes_title',
                defaultMessage: "What's included in the subscription along with {brandName}?",
                description: 'Заголовок вопроса в разделе «Вопросы и ответы»',
            },
            { brandName }
        ),
    faq__subscription_includes_answer: (
        intl: IntlShape,
        {
            brandName,
            br,
            ul,
            li,
        }: {
            brandName: string;
            br: ReactElement;
            ul: (chunks: any) => ReactElement;
            li: (chunks: any) => ReactElement;
        }
    ) =>
        intl.formatMessage(
            {
                id: 'allplay.faq_subscription_includes_answer',
                defaultMessage:
                    'You can use all the benefits of the Yandex Plus subscription:{br}<ul><li>Online streaming services {brandName} and Kinopoisk with exclusive premieres, movies, TV series, cartoons, and TV channels.</li><li>Yandex Music with your favorite tracks, the My Vibe smart recommendation system, and podcasts.</li><li>Yandex Books with a large library of novels, comic books, and audiobooks.</li><li>Cashback as Plus points in Yandex Go.</li></ul>',
                description: 'Текст ответа на вопрос в разделе «Вопросы и ответы»',
            },
            { brandName, br, ul, li }
        ),
    faq__about_plus_title: (intl: IntlShape, { brandName }: { brandName: string }) =>
        intl.formatMessage(
            {
                id: 'allplay.faq_about_plus_title',
                defaultMessage: "I'm subscribed to Yandex Plus. Is {brandName} included?",
                description: 'Текст ответа на вопрос в разделе «Вопросы и ответы»',
            },
            { brandName }
        ),
    faq__about_plus_answer: (
        intl: IntlShape,
        {
            brandName,
            personalLink,
        }: { brandName: string; personalLink: (chunks: any) => ReactElement }
    ) =>
        intl.formatMessage(
            {
                id: 'allplay.faq_about_plus_answer',
                defaultMessage:
                    'You can add {brandName} to Yandex Plus in your <personalLink>personal account</personalLink>. Yandex Plus Multi and Yandex Plus Multi & Amediateka already include Allplay.',
                description: 'Текст ответа на вопрос в разделе «Вопросы и ответы»',
            },
            { brandName, personalLink }
        ),
    faq__does_not_work_title: (intl: IntlShape, { brandName }: { brandName: string }) =>
        intl.formatMessage(
            {
                id: 'allplay.faq_does_not_work_title',
                defaultMessage: "I paid for {brandName}, but it's not working. What should I do?",
                description: 'Заголовок вопроса в разделе «Вопросы и ответы»',
            },
            { brandName }
        ),
    faq__does_not_work_answer: (
        intl: IntlShape,
        {
            brandName,
            supportLink,
        }: { brandName: string; supportLink: (chunks: any) => ReactElement }
    ) =>
        intl.formatMessage(
            {
                id: 'allplay.faq_does_not_work_answer',
                defaultMessage:
                    "Make sure you're logged in to the {brandName} website or app with the account that has the active subscription. If you need help, please contact <supportLink>support in the chat</supportLink>.",
                description: 'Текст ответа на вопрос в разделе «Вопросы и ответы»',
            },
            { brandName, supportLink }
        ),
    faq__how_unsubscribe_title: (intl: IntlShape, { brandName }: { brandName: string }) =>
        intl.formatMessage(
            {
                id: 'allplay.faq_how_unsubscribe_title',
                defaultMessage: 'How do I cancel {brandName}?',
                description: 'Заголовок вопроса в разделе «Вопросы и ответы»',
            },
            { brandName }
        ),
    faq__how_unsubscribe_answer: (
        intl: IntlShape,
        {
            br,
            personalLink,
            bold,
        }: {
            br: ReactElement;
            personalLink: (chunks: any) => ReactElement;
            bold: (chunks: any) => ReactElement;
        }
    ) =>
        intl.formatMessage(
            {
                id: 'allplay.faq_how_unsubscribe_answer',
                defaultMessage:
                    'You can cancel it in your <personalLink>personal account</personalLink>.{br}{br}1. Log in to your account with an active subscription.{br}2. Scroll the page down and choose <bold>Cancel subscription</bold>.{br}3. Follow the instructions on the screen.',
                description: 'Текст ответа на вопрос в разделе «Вопросы и ответы»',
            },
            { br, personalLink, bold }
        ),
    faq__how_manage_title: (intl: IntlShape, { brandName }: { brandName: string }) =>
        intl.formatMessage(
            {
                id: 'allplay.faq_how_manage_title',
                defaultMessage: 'How do I manage {brandName}?',
                description: 'Заголовок вопроса в разделе «Вопросы и ответы»',
            },
            { brandName }
        ),
    faq__how_manage_answer: (
        intl: IntlShape,
        { personalLink }: { personalLink: (chunks: any) => ReactElement }
    ) =>
        intl.formatMessage(
            {
                id: 'allplay.faq_how_manage_answer',
                defaultMessage:
                    'You can check your subscription status, switch to another plan, or update your payment method in your <personalLink>personal account</personalLink>.',
                description: 'Текст ответа на вопрос в разделе «Вопросы и ответы»',
            },
            { personalLink }
        ),
    faq__available_title: (intl: IntlShape, { brandName }: { brandName: string }) =>
        intl.formatMessage(
            {
                id: 'allplay.faq_available_title',
                defaultMessage: 'Where is {brandName} available?',
                description: 'Заголовок вопроса в разделе «Вопросы и ответы»',
            },
            { brandName }
        ),
    faq__available_answer: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'allplay.faq_available_answer',
            defaultMessage: 'Only in Uzbekistan.',
            description: 'Текст ответа на вопрос в разделе «Вопросы и ответы»',
        }),
    faq__devices_title: (intl: IntlShape, { brandName }: { brandName: string }) =>
        intl.formatMessage(
            {
                id: 'allplay.faq_devices_title',
                defaultMessage: 'Which devices and languages does {brandName} support?',
                description: 'Текст ответа на вопрос в разделе «Вопросы и ответы»',
            },
            { brandName }
        ),
    faq__devices_answer: (
        intl: IntlShape,
        {
            brandName,
            allplayLink,
        }: { brandName: string; allplayLink: (chunks: any) => ReactElement }
    ) =>
        intl.formatMessage(
            {
                id: 'allplay.faq_devices_answer',
                defaultMessage:
                    '{brandName} is available in the app on smartphones with Android or iOS, on Smart TV and Android TV, and in the web version at <allplayLink>allplay.uz</allplayLink>. You can set the interface language to Uzbek, Russian, or English.',
                description: 'Текст ответа на вопрос в разделе «Вопросы и ответы»',
            },
            { brandName, allplayLink }
        ),
};
